import { cusAxios, PREFIX } from './main';

const getDepositGate = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/input/gate_list`
  });
  return response;
};

const getDepositStatusList = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/input/status_list`
  });
  return response;
};

const getDepositPlayers = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/input/user_list`,
    data: { groupId }
  });
  return response;
};

const getDepositList = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/input/list`,
    data: data
  });
  return response;
};

const getDepositSearch = async ({ groupId, sample, pageSize, pageNo }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/input/search`,
    data: { groupId, sample, pageSize, pageNo }
  });
  return response;
};

const getDepositRawList = async ({ invoiceId, gate }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/input/raw_list`,
    data: { invoiceId, gate }
  });
  return response;
};

const getPayoutStatuses = async () => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/output/status_list`
  });
  return response;
};

const getPayoutPlayers = async ({ groupId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/output/user_list`,
    data: { groupId }
  });
  return response;
};

const getPayoutList = async (data) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/output/list`,
    data: data
  });
  return response;
};

const getPayoutRaws = async ({ invoiceId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/output/raw_list`,
    data: { invoiceId }
  });
  return response;
};

const payout = async ({ invoiceId, method, comment, gateFee }) => {
  let response = await cusAxios(
    {
      method: 'POST',
      url: `${PREFIX}/api/adminsite/output/payout`,
      data: { invoiceId, method, comment, gateFee }
    },
    [],
    true
  );
  return response;
};

const reject = async ({ invoiceId, refund, comment }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/output/reject`,
    data: { invoiceId, refund, comment }
  });
  return response;
};

const statusCheck = async ({ invoiceId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/output/status_get`,
    data: { invoiceId }
  });
  return response;
};

const payoutGates = async ({ casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/output/gate_list`,
    data: { casinoId }
  });
  return response;
};
const getPayoutCommission = async ({ amount, currency, casinoId }) => {
  let response = await cusAxios({
    method: 'POST',
    url: `${PREFIX}/api/adminsite/output/gate_fee`,
    data: { amount, currency, casinoId }
  });
  return response;
};

export const API_FINANCE = {
  deposit: {
    gates: getDepositGate,
    statuses: getDepositStatusList,
    players: getDepositPlayers,
    list: getDepositList,
    search: getDepositSearch,
    raws: getDepositRawList
  },
  payout: {
    raws: getPayoutRaws,
    list: getPayoutList,
    players: getPayoutPlayers,
    statuses: getPayoutStatuses,
    payout: payout,
    reject: reject,
    gates: payoutGates,
    statusCheck: statusCheck,
    commission: getPayoutCommission
  }
};
